import React from 'react';
import { CtaButton } from './CtaButton';
import { FieldDiamond } from './FieldDiamond';
import { PackShot } from './PackShot';
import { images } from '../data/images';
const chips = ['6 Volumes', '5 Bonuses', '300 Pages', '43 Ready-to-Run Practices', 'A full season, planned'];
const levels = ['6U–8U', '10U–12U', 'HS & Rec'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it and coach from it'];
export function Hero() {
  return <section className="wood-bench relative w-full overflow-hidden border-b-4 border-gold" data-id="element-135" data-mp="xanoxzt57hfd">
      {/* Diamante de tiza, motivo de pizarra de coach */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-136" data-mp="s9q8psrp0xgi">
        <FieldDiamond className="absolute -left-16 top-28 h-[300px] w-[300px] text-ice/[0.06] sm:h-[360px] sm:w-[360px]" data-id="element-137" data-mp="nb6mrsd3nlo5" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 pt-6 pb-16 sm:pt-10 sm:pb-20" data-id="element-138" data-mp="3czfk1vt6u14g">
        {/* Mobile order: headline → CTA (above the fold) → image → details.
            Desktop: copy + CTA + details on the left, image on the right. */}
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-x-14 lg:gap-y-8" data-id="element-139" data-mp="3o7vkflb27pxt">
          <div data-id="element-140" data-mp="39b4gcyqfxq1v">
            <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-141" data-mp="399jm7a81g94j">
              The 4-Block Practice System for softball coaches
            </p>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-[40px] leading-[.95] tracking-tight sm:text-6xl md:text-7xl" data-id="element-142" data-mp="30iaweo01u2ho">
              Your next softball practice is{' '}
              <span className="text-gold" data-id="element-143" data-mp="2qk3muq83ampp">already planned.</span>
            </h1>
            <p className="mt-4 max-w-xl text-base text-white/75 sm:mt-5 sm:text-lg" data-id="element-144" data-mp="2qi0lxb5ef967">
              A six-volume coaching system: a full season of ready-to-run
              practices &mdash; warm-ups, drills, game situations and printable
              worksheets, for every age and level.
              <span className="hidden sm:inline" data-id="element-145" data-mp="2lmv4aoj14gnx">
                {' '}
                Not a pile of drills off the internet: the practice itself,
                built in 4 blocks, ready to run.
              </span>
            </p>

            <div className="mt-6 w-full max-w-md" data-id="element-146" data-mp="iboyiltrcouw">
              <CtaButton data-id="element-147" data-mp="ichx2zikc81y">Get Softball Season-Ready</CtaButton>
            </div>

            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-148" data-mp="degcub9ei2ow">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-149" data-mp="1ayt7f1vz1nby">
                  <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-150" data-mp="16344cokqtoaw" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:row-span-2" data-id="element-151" data-mp="x1nuqj1r5q7q">
            {images.hero ? <img src={images.hero} alt="The six Softball Season-Ready volumes on a dugout bench with a clipboard, glove and softballs" width={1568} height={1041} className="w-full h-auto rounded-2xl shadow-card" data-id="element-152" data-mp="x3h1dycd8afq" /> : <PackShot data-id="element-153" data-mp="21aekpmas4vd9" />}
          </div>

          <div data-id="element-154" data-mp="218to7r4wn2cr">
            <ul className="flex flex-wrap gap-2" data-id="element-155" data-mp="218jzs7zid396">
              {chips.map(chip => <li key={chip} className="rounded-md border border-ice/25 bg-ice/[0.06] px-3 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ice" data-id="element-156" data-mp="267wluqik26ap">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3" data-id="element-157" data-mp="2kx2iq7tx7kff">
              <p className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-158" data-mp="2p1a5hzgtiqb0">
                Every practice in three levels
              </p>
              <ul className="flex flex-wrap gap-2" data-id="element-159" data-mp="un98lk4twddk">
                {levels.map(level => <li key={level} className="rounded-full border border-gold/50 px-3 py-1 text-xs font-bold text-gold" data-id="element-160" data-mp="zl12uksy4bkx">
                    {level}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}